var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 24C46 17.3726 40.6274 12 34 12H30C28.8954 12 28 12.8954 28 14V34C28 35.1046 28.8954 36 30 36H34C40.6274 36 46 30.6274 46 24Z",
    fill: "#C4E6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C7.37258 12 2 17.3726 2 24C2 30.6274 7.37258 36 14 36H18C19.1046 36 20 35.1046 20 34C20 32.8954 19.1046 32 18 32H14C9.58172 32 6 28.4182 6 24C6 19.5817 9.58172 16 14 16H18C19.1046 16 20 15.1046 20 14C20 12.8954 19.1046 12 18 12H14ZM34 12C40.6274 12 46 17.3726 46 24C46 30.6274 40.6274 36 34 36H30C28.8954 36 28 35.1046 28 34C28 32.8954 28.8954 32 30 32H34C38.4182 32 42 28.4182 42 24C42 19.5817 38.4182 16 34 16H30C28.8954 16 28 15.1046 28 14C28 12.8954 28.8954 12 30 12H34Z",
    fill: "#024493"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 24C10 22.8954 10.8954 22 12 22H36C37.1046 22 38 22.8954 38 24C38 25.1046 37.1046 26 36 26H12C10.8954 26 10 25.1046 10 24Z",
    fill: "#1E93FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bbb2fece01de2eadd57fe4ff8fb1b002.svg";
export { ForwardRef as ReactComponent };